import type { DirectiveBinding } from 'vue'

interface ExtendedClickOutsideHTMLElement extends HTMLElement {
  clickOutsideEvent(event: Event): void
}

const vClickOutside = {
  mounted(el: ExtendedClickOutsideHTMLElement, binding: DirectiveBinding) {
    const isCaller = (event: Event) => {
      const target = event.target as EventTarget
      if (target instanceof HTMLElement || target instanceof SVGElement) {
        return (
          (target.hasAttribute('click-outside-caller') && el.contains(event.target as HTMLElement)) ||
          (target.parentElement instanceof HTMLElement && target.parentElement.hasAttribute('click-outside-caller')) ||
          (target.parentElement?.parentElement instanceof HTMLElement &&
            target.parentElement.parentElement.hasAttribute('click-outside-caller'))
        )
      }
    }
    const clickOutsideEventHandler = (event: Event) => {
      if (!el.contains(event.target as HTMLElement) && el !== event.target && !isCaller(event)) {
        binding.value(event)
      }
    }
    el.clickOutsideEvent = clickOutsideEventHandler
    document.addEventListener('click', clickOutsideEventHandler)
  },
  unmounted(el: ExtendedClickOutsideHTMLElement) {
    document.removeEventListener('click', el.clickOutsideEvent)
  },
}

export default vClickOutside
